<div class="filter-body">
  <header class="filter-header">
    <button mat-icon-button class="button-close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="filter-main options px-3 pt-3 pb-1">
    <form action="" [formGroup]="filterForm">
      <fieldset class="field-section -m-2" (click)="$event.stopPropagation()">
        <ng-template ngFor let-field [ngForOf]="filterFormData['formFields']" let-i="index">
          <div [ngSwitch]="field['fieldType']" class="field-box inline-block" [ngClass]="field['widthClass']">
            <div *ngSwitchCase="'text'" class="input-box m-2">
              <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
              <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full">
                <input autocomplete="off" matInput [type]="field['inputType'] || ''" [name]="field['formFieldName']" [formControlName]="field['formFieldName']" [placeholder]="field['placeholder']" />
              </mat-form-field>
            </div>
            <div class="m-2" *ngSwitchCase="'dropdown'">
              <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
              <sp-mat-select-search
                class="w-full"
                [formControlName]="field['formFieldName']"
                [dataSource]="field['options']"
                [placeholder]="field['placeholder']"
                [config]="{ search: true, titleCase: true }"
                [attrDataTestId]="'asset-filter_' + field['formFieldName']"
                (selectedChange)="onValueChange($event, field)"
              ></sp-mat-select-search>
            </div>
            <div *ngSwitchCase="'textarea'" class="input-box m-2">
              <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
              <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full">
                <textarea matInput type="text" [name]="field['formFieldName']" [formControlName]="field['formFieldName']" [placeholder]="field['placeholder']"></textarea>
              </mat-form-field>
            </div>
            <div class="m-2" *ngSwitchCase="'date'">
              <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
              <mat-form-field appearance="outline" color="primary" class="input-template template-name w-full">
                <input
                  autocomplete="off"
                  matInput
                  [min]="field['minDate']"
                  [max]="field['maxDate']"
                  [matDatepicker]="picker"
                  [formControlName]="field['formFieldName']"
                  [placeholder]="field['placeholder']"
                />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
            <div *ngSwitchCase="'label'" class="mx-4 mt-4 font-bold">
              {{ field['fieldLabel'] ? field['fieldLabel'] : field.value['formControlName'] }}
            </div>
            <div class="m-2" *ngSwitchCase="'autocomplete'">
              <span class="field-label" *ngIf="!field['hideLabel']">{{ field['fieldLabel'] }}</span>
              <mat-form-field color="primary" class="input-template template-name w-full" appearance="outline">
                <input type="text" [placeholder]="field['placeholder']" matInput [formControlName]="field['formFieldName']" [matAutocomplete]="auto" />
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                  <mat-option *ngFor="let option of field['options']" [value]="option.id">
                    {{ option.name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </ng-template>
      </fieldset>
    </form>
  </div>

  <div class="filter-footer">
    <button (click)="resetForm()" mat-flat-button class="button-secondary">
      <mat-icon>close</mat-icon>
      <span class="px-2 font-bold" i18n>Reset all</span>
    </button>
    <button (click)="filterData()" mat-flat-button class="button-primary">
      <mat-icon>check</mat-icon>
      <span class="px-2 font-bold" i18n>Apply</span>
    </button>
  </div>
</div>
